
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/disk",
      function () {
        return require("private-next-pages/disk.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/disk"])
      });
    }
  